<template>
    <div>
        <Checkin v-if="post.operation == 'create_kpi_checkin'" :post="post" />
        <Delete v-if="post.operation === 'delete_kpi_checkin'" :post="post" />
        <Update v-if="this.validOperations.includes(post.operation)" :post="post" />
    </div>
</template>

<script>
import { Checkin, Delete, Update } from './goal'

export default {
    name: 'PostContentGoal',
    props: {
        post: {
            type: Object,
            required: true,
        },
    },
    components: {
        Checkin,
        Delete,
        Update,
    },
    computed: {
        validOperations() {
            return [
                'update_kpi_checkin',
                'update_kpi_checkin_simulated_accomplished',
                'update',
                'update_owner_evaluation',
                'update_manager_evaluation',
                'update_kpi_checkin_committee_evaluation',
                'create_kpi_checkin_owner_evaluation',
                'create_kpi_checkin_manager_evaluation',
                'create_kpi_checkin_committee_evaluation',
            ]
        },
    },
}
</script>

<style></style>
